import { gql } from '@apollo/client';

export default gql`
  query getRentitems($isRTL: Boolean) {
    getRentitems(isRTL: $isRTL) {
      ok
      error
      data {
        _id
        branch
        autoNo
        docNo
        itemType
        barcode

        disabled
        additionId

        name
        nameAr
        desc
        cost
        qty
        price
        unit
        photo

        categoryId
        categoryName
        categoryNameAr

        brandId
        brandName
        brandNameAr

        departmentId
        departmentName
        departmentNameAr
        departmentColor

        employeeId
        employeeName
        employeeNameAr
        employeeColor
        employeePhone

        resourseId
        resourseName
        resourseNameAr
        resourseColor

        userId

        createdAt
        updatedAt
      }
    }
  }
`;
